import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#028e37",
      light: "#02bc6b",
    },
    secondary: {
      main: "#061e06",
    },
  },
});

export default theme;
